import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Switch } from "../../components/ui/switch";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";
import { PageHeader } from "../../components/common/States";
import AnnouncementsManager from "../../components/comms/AnnouncementsManager";
import { fmtDate } from "../../lib/labels";

const TRANSACTIONAL = [["signup", "Inscription et confirmation d'email", true], ["invitation", "Invitations collaborateurs", true],
  ["feedback_reply", "Réponses aux avis et nouveaux messages", true], ["password_reset", "Réinitialisation du mot de passe", true],
  ["company_status", "Statut du compte entreprise", true], ["monthly_report", "Rapports mensuels", true],
  ["tickets", "Tickets de support", false], ["invoices", "Factures", false], ["payments", "Paiements", false]];

const Settings = () => {
  const { data, reload } = useApi("/admin/email-settings");
  const [f, setF] = useState(null);
  useEffect(() => { if (data) { setF({ provider: data.provider, sender_name: data.sender_name, reply_to: data.reply_to || "", marketing_enabled: data.marketing_enabled }); } }, [data]);
  if (!f) return null;
  const save = async () => { try { await api.put("/admin/email-settings", { ...f, reply_to: f.reply_to || null }); toast.success("Paramètres enregistrés"); reload(); } catch (e) { toast.error(formatApiError(e)); } };
  const cap = data.providers[0].capabilities;
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="card-surface space-y-3 p-5" data-testid="email-settings">
        <p className="font-display font-semibold">Fournisseur d'email</p>
        <select className="field-select" value={f.provider} onChange={(e) => setF({ ...f, provider: e.target.value })} data-testid="email-provider-select">{data.providers.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}</select>
        <p className="text-xs text-slate-500">Capacités : acceptation {cap.accepted ? "✓" : "✗"} · livraison {cap.delivered ? "✓" : "non fournie"} · rebonds {cap.bounced ? "✓" : "non fournis"}</p>
        <Input placeholder="Nom d'expéditeur" value={f.sender_name} onChange={(e) => setF({ ...f, sender_name: e.target.value })} data-testid="email-sender-input" />
        <Input placeholder="Adresse de réponse (facultatif)" value={f.reply_to} onChange={(e) => setF({ ...f, reply_to: e.target.value })} data-testid="email-replyto-input" />
        <label className="flex items-center justify-between text-sm">Autoriser les campagnes marketing des entreprises<Switch checked={f.marketing_enabled} onCheckedChange={(v) => setF({ ...f, marketing_enabled: v })} data-testid="email-marketing-switch" /></label>
        <Button onClick={save} data-testid="email-settings-save">Enregistrer</Button>
        <p className="text-xs text-slate-500" data-testid="email-stats">Volumes : {Object.entries(data.stats).map(([k, v]) => `${k} → ${Object.entries(v).map(([s, n]) => `${s} ${n}`).join(", ")}`).join(" · ") || "aucun envoi"}</p>
      </div>
      <div className="card-surface p-5" data-testid="transactional-list">
        <p className="font-display font-semibold">Emails transactionnels (séparés des campagnes)</p>
        <ul className="mt-2 space-y-1 text-sm">{TRANSACTIONAL.map(([k, l, on]) => <li key={k} className="flex justify-between"><span>{l}</span><span className={on ? "text-emerald-700" : "text-slate-400"}>{on ? "Actif" : "Prévu (module à venir)"}</span></li>)}</ul>
        <p className="mt-2 text-xs text-slate-400">Envoyés sans condition de consentement marketing, jamais avec un lien commercial.</p>
      </div>
    </div>
  );
};

const Log = () => {
  const [kind, setKind] = useState("");
  const { data } = useApi(`/admin/email-log?kind=${kind}`);
  return (
    <div className="card-surface p-5" data-testid="email-log">
      <select className="field-select mb-3 w-56" value={kind} onChange={(e) => setKind(e.target.value)} data-testid="email-log-kind"><option value="">Tous</option><option value="transactional">Transactionnels</option><option value="marketing">Marketing</option><option value="service">Service (admin)</option></select>
      <div className="divide-y text-sm">{(data || []).map((l) => <p key={l.id} className="py-1.5">{fmtDate(l.at)} · {l.kind} · {l.category} · {l.to} · <b>{l.status === "accepted" ? "accepté" : l.status}</b>{l.error ? ` — ${l.error}` : ""}</p>)}</div>
    </div>
  );
};

export default function AdminCommunication() {
  return (
    <div>
      <PageHeader title="Communication" description="Annonces aux entreprises clientes, fournisseur d'email et journal des envois." />
      <Tabs defaultValue="ann">
        <TabsList className="mb-6"><TabsTrigger value="ann" data-testid="admin-tab-ann">Annonces</TabsTrigger><TabsTrigger value="settings" data-testid="admin-tab-settings">Fournisseur & emails</TabsTrigger><TabsTrigger value="log" data-testid="admin-tab-log">Journal</TabsTrigger></TabsList>
        <TabsContent value="ann"><AnnouncementsManager base="/admin/announcements" allowEmail categories={["annonce", "mise_a_jour", "maintenance", "abonnement"]} audiences={["all", "active"]} /></TabsContent>
        <TabsContent value="settings"><Settings /></TabsContent>
        <TabsContent value="log"><Log /></TabsContent>
      </Tabs>
    </div>
  );
}
